// Vista de detalle del panel (ficha de parada o de línea) apilable: línea → parada → «‹» vuelve
// a la línea → «‹» vuelve a la pestaña. Cada vista se monta en el mismo contenedor y devuelve
// su función de limpieza (temporizadores, suscripciones, líneas temporales en el mapa).

export interface DetailView {
  mount(el: HTMLElement, back: () => void): () => void;
}

export interface DetailHost {
  push(view: DetailView): void;
  back(): void;
  clear(): void;
  isOpen(): boolean;
}

export function createDetailHost(
  el: HTMLElement,
  onVisible: (open: boolean) => void,
): DetailHost {
  const stack: DetailView[] = [];
  let unmount: (() => void) | null = null;

  const show = (): void => {
    unmount?.();
    unmount = null;
    el.innerHTML = "";
    const top = stack[stack.length - 1];
    if (!top) {
      el.hidden = true;
      onVisible(false);
      return;
    }
    el.hidden = false;
    onVisible(true);
    el.scrollTop = 0;
    unmount = top.mount(el, () => host.back());
  };

  const host: DetailHost = {
    push(view) {
      stack.push(view);
      show();
    },
    back() {
      stack.pop();
      show();
    },
    clear() {
      stack.length = 0;
      show();
    },
    isOpen: () => stack.length > 0,
  };
  return host;
}
